import React from 'react'
import { node, string } from 'prop-types'
import { css } from '@emotion/react'

const badgeCss = (theme) => css`
  background: ${theme.colors.yellow};
  font-size: 10px;
  font-weight: ${theme.font.bold};
  padding: 0px 6px;
  border-radius: 1000px;
  position: relative;
  top: 2px;
`

const Badge = ({ children, className }) => {
  return (
    <span css={badgeCss} className={className}>
      {children}
    </span>
  )
}

Badge.propTypes = {
  children: node,
  className: string,
}

export default Badge
